// extracted by mini-css-extract-plugin
export default {"noMatchingInstruction":"NewCustomerSelect_noMatchingInstruction__-6ERo"};